/** Fundo animado com "blobs" verdes desfocados (igual ao tema SERCAMP). */
export default function AnimatedBackground() {
  return (
    <div className="bg" aria-hidden="true">
      <span className="blob b1" />
      <span className="blob b2" />
      <span className="blob b3" />
    </div>
  );
}
